<div class="dialog-container" *ngIf="!linkOpened" style="height: 304px;">
    <div class="title">
        Create an Azure Account
    </div>

    <div class="content">
        <p>You need to complete this request in Galileo.</p>

        <p>Then come back to CloudServe, refresh this page and your account status will appear.</p>
    </div>

    <div class="button-container">
        <button (click)="close()" class="btn">Cancel</button>
        <button class="btn btn-next" (click)="openLink()">Go to Galileo</button>
    </div>
</div>

<div class="dialog-container" *ngIf="linkOpened" style="height: 258px;">
    <div class="title">
        Did you Submit a Request?
    </div>

    <div class="content">
        <p>To create an Azure account you need to submit a request in Galileo. Once you have completed the form, refresh this page and view the account status.</p>
    </div>

    <div class="button-container">
        <div>
            <button (click)="close()" class="btn">Cancel</button>
        </div>
        
        <div>
            <button class="btn" (click)="openLink()">Go to Galileo</button>
            <button class="btn btn-next ref-btn" (click)="refreshPage()">Refresh</button>
        </div>
    </div>
</div>
